<template>
  <div class="ms-information">
    <div class="ms-infor">
      <h3>为了更好地向您提供后续服务，请您认真填写一下资料：</h3>
      <!-- 性别 -->
      <div class="infor-group">
        <h4>性别</h4>
        <div class="gender">
          <label :class="[userInfo.gender==1?'on':'']" for="man">
            <img src="@a/ms_system/man.png" alt />男
            <input id="man" type="radio" :value="1" v-model="userInfo.gender" />
          </label>
          <label :class="[userInfo.gender==2?'on':'']" for="woman">
            <img src="@a/ms_system/woman.png" alt />女
            <input id="woman" type="radio" :value="2" v-model="userInfo.gender" />
          </label>
        </div>
      </div>
      <!-- 年龄 -->
      <div class="infor-group">
        <h4>年龄</h4>
        <input type="text" placeholder="请填写你的年龄（必填）" @input="validationHandle()" v-model="userInfo.age" />
      </div>
      <!-- 工作城市 -->
      <div class="infor-group">
        <h4>城市</h4>
        <div class="select">
          <span
            :class="['input',userInfo.city?'color3':'']"
            @click="citysShow=true"
          >{{userInfo.city?userInfo.city:'请填写你所在的工作城市（必填）'}}</span>
          <span class="bottom">
            <img @click="citysShow=true" src="@a/action-bottom.png" />
          </span>
        </div>
      </div>
      <!-- 学历 -->
      <div class="infor-group">
        <h4>学历</h4>
        <div class="select">
          <span
            :class="['input',userInfo.degree?'color3':'']"
            @click="selectHandle('degree')"
          >{{userInfo.degree?userInfo.degree:'请选择学历（必选）'}}</span>
          <span class="bottom">
            <img @click="selectHandle('degree')" src="@a/action-bottom.png" />
          </span>
        </div>
      </div>
      <!-- 在职状态 -->
      <div class="infor-group">
        <h4>在职状态</h4>
        <div class="select">
          <span
            :class="['input',userInfo.state?'color3':'']"
            @click="selectHandle('state')"
          >{{userInfo.state?userInfo.state:'请选择在职状态'}}</span>
          <span class="bottom">
            <img @click="selectHandle('state')" src="@a/action-bottom.png" />
          </span>
        </div>
      </div>
      <!-- 从事职业 -->
      <div class="infor-group">
        <h4>从事职业</h4>
        <input type="text" placeholder="请填写从事的职业" v-model="userInfo.job" />
      </div>
      <!-- 工作年限 -->
      <div class="infor-group">
        <h4>工作年限</h4>
        <div class="select">
          <span
            :class="['input',userInfo.workage?'color3':'']"
            @click="selectHandle('workage')"
          >{{userInfo.workage?userInfo.workage:'请选择工作年限（必选）'}}</span>
          <span class="bottom">
            <img @click="selectHandle('workage')" src="@a/action-bottom.png" />
          </span>
        </div>
      </div>
      <!-- 年收入 -->
      <div class="infor-group">
        <h4>年收入</h4>
        <div class="select">
          <span
            :class="['input',userInfo.income?'color3':'']"
            @click="selectHandle('income')"
          >{{userInfo.income?userInfo.income:'请选择年收入'}}</span>
          <span class="bottom">
            <img @click="selectHandle('income')" src="@a/action-bottom.png" />
          </span>
        </div>
      </div>
      <!-- 公司规模 -->
      <div class="infor-group">
        <h4>公司规模</h4>
        <div class="select">
          <span
            :class="['input',userInfo.scale?'color3':'']"
            @click="selectHandle('scale')"
          >{{userInfo.scale?userInfo.scale:'请选择公司规模'}}</span>
          <span class="bottom">
            <img @click="selectHandle('scale')" src="@a/action-bottom.png" />
          </span>
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <div class="submit-group">
      <a class="skip" @click="toceping()">跳过</a>
      <a :class="['submitBtn',bool?'on':'']" @click="saveFrom()">提交</a>
    </div>
    <!-- 省市弹出层 @close="pickerShowClick(false)" -->
    <van-popup v-model="citysShow" position="bottom">
      <van-area
        ref="areas"
        :area-list="areaList"
        :columns-num="2"
        :value="userInfo.city"
        @cancel="citysShow=false"
        @confirm="cityCfm"
      />
    </van-popup>
    <!-- 下拉窗口 -->
    <van-popup class="popup" v-model="pickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="options[selectType]"
        :default-index="0"
        @cancel="pickerShow=false"
        @confirm="puckerCfm"
      />
    </van-popup>
  </div>
</template>

<script>
import areaList from "@/utils/area";
import { my,save_userinfo } from "@/api/measurement_system";
export default {
  data() {
    return {
      userInfo: {
        gender: 1, //性别
        age: null, //年龄
        city: "", //城市
        degree: "", //学历
        state: "", //在职状态
        job: "", //从事职业
        workage: "", //工作年限
        income: "", //年收入
        scale: "" //公司规模
      },
      areaList, //省市数组
      citysShow: false,
      options: {}, //选项
      pickerShow: false, //下拉窗选项
      selectType: "", //所点击的下拉窗
      bool: false //必填验证
    };
  },
  methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 跳转测评
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-13 15:33:54
      */
      toceping(){
          this.$router.push(this.$route.query.link);
      },
    /*
     *@param:
     *@return:
     *@Description: 提交表单
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 12:19:44
     */
    saveFrom() {
      if (!this.bool) {
        this.$toast("必填项不能为空！");
        return;
      }
      // loading
      this.$toast.loading({
        mask: true,
        message: "提交中..."
      });
      save_userinfo(this.userInfo).then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          return;
        }
        this.$toast.clear();
        this.$toast(data.msg);
      });
    },
    /*
     *@param:
     *@return:
     *@Description: 验证数据是否为空
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 12:09:34
     */
    validationHandle() {
      let u = this.userInfo;
      if (u.age && u.city && u.degree && u.workage) {
        this.bool = true;
      } else {
        this.bool = false;
      }
    },
    /*
     *@param: val 当前点击的下拉窗
     *@return:
     *@Description: 点击选择框触发
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 11:46:29
     */
    selectHandle(val) {
      this.selectType = val;
      this.pickerShow = true;
    },
    /*
     *@Description: 下拉选择的值
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-07 18:51:09
     */
    puckerCfm(val) {
      this.userInfo[this.selectType] = val;
      this.validationHandle();
      this.pickerShow = false;
    },
    // 确认选择城市触发
    cityCfm(picker) {
      this.userInfo.city = picker[0].name + " " + picker[1].name;
      this.validationHandle();
      this.citysShow = false;
    },
    /*
     *@Description: 初始化请求数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-11 18:08:59
     */
    pullData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      my().then(data => {
        this.options = data.options;
        this.userInfo = data.info;
        this.bodyShow = true;
        this.validationHandle();
        
        this.$toast.clear();
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss">
.ms-information {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  top: 0;
  left: 0;
  background-color: #ffffff;
  padding: 40px 30px 0 30px;
  .ms-infor {
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    padding: 60px 30px;
    h3 {
      font-size: 34px;
      color: #333333;
      margin-bottom: 50px;
      font-weight: 400;
    }
    .infor-group {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0px;
      }
      h4 {
        font-size: 28px;
        color: #333333;
        font-weight: 400;
        line-height: 1;
        margin-bottom: 10px;
      }
      .gender {
        display: flex;
        width: 332px;
        border-radius: 8px;
        background-color: #cccccc;
        align-items: center;
        margin-top: 0;
        label {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 70px;
          border-radius: 8px;
          background-color: #cccccc;
          color: #ffffff;
          text-align: center;
          font-size: 34px;
          &:nth-child(2) {
            margin-left: -1px;
          }
          img {
            width: 20px;
            height: 32px;
            margin-right: 16px;
          }
          input {
            display: none;
          }
        }
        label.on {
          background-color: #dc5a38;
        }
      }
      input[type="text"] {
        border: 2px solid #cccccc;
        border-radius: 8px;
        line-height: 70px;
        padding: 0 20px;
        font-size: 26px;
      }
      // select
      .select {
        position: relative;
        .input {
          color: #999999;
          display: block;
          border: 2px solid #cccccc;
          border-radius: 8px;
          line-height: 70px;
          padding: 0 20px;
          font-size: 26px;
        }
        .input.color3 {
          color: #333333;
        }
        .bottom {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 18px;
          img {
            width: 28px;
            height: 16px;
          }
        }
      }
    }
  }
  //   提价按钮组
  .submit-group {
    margin: 80px auto 108px;
    font-size: 32px;
    display: flex;
    justify-content: center;
    .skip {
      display: block;
      width: 174px;
      text-align: center;
      line-height: 64px;
      color: #eb5032;
      border-radius: 32px;
      border: 2px solid #eb5032;
      margin-right: 80px;
    }
    .submitBtn {
      display: block;
      width: 174px;
      text-align: center;
      line-height: 64px;
      color: #ffffff;
      border-radius: 32px;
      background-color: #cccccc;
    }
    .submitBtn.on {
      background-color: #eb5032;
    }
  }
}
</style>